import type ValidationInfo from '../../../validation/validation-info';
import { IdHelper } from '../../../helpers/id.helper';

export interface IRadioGroupFormGroupState {
  value: string;
  validationInfo: ValidationInfo;
}

function RadioFormGroup({
  id,
  className,
  labelText,
  rowLayout = false,
  rowLayoutSmUp = false,
  disabled = false,
  options,
  state,
  onChange,
}: {
  id?: string;
  className?: string;
  labelText?: string;
  rowLayout?: boolean;
  rowLayoutSmUp?: boolean;
  disabled?: boolean;
  options: { value: string; text: string }[];
  state: IRadioGroupFormGroupState;
  onChange?: (value: string) => void;
}) {
  const idWithFallback = id ?? IdHelper.newUniqueId('radio-group-form-group-');

  return (
    <fieldset className={`radio-group-form-group ${className ?? ''}`}>
      <legend>{labelText ?? ''}</legend>
      <div className={`d-flex ${rowLayout ? `flex-wrap ${rowLayoutSmUp ? 'flex-column flex-sm-row' : 'flex-row'}` : 'flex-column'} gap-2`}>
        {options.map(({ value, text }) => (
          <div key={value} className={`form-check mb-0 ${state.validationInfo.isInvalid ? 'is-invalid' : ''} ${rowLayout ? `${rowLayoutSmUp ? 'me-sm-3' : 'me-3'}` : ''} `}>
            {/* eslint-disable-next-line jsx-a11y/role-supports-aria-props */}
            <input
              type="radio"
              className={`form-check-input ${state.validationInfo.isInvalid ? 'is-invalid' : ''}`}
              name={idWithFallback}
              id={`${idWithFallback}-${value.toLocaleLowerCase()}`}
              value={value}
              checked={state.value === value}
              disabled={disabled}
              onChange={() => onChange?.(value)}
              aria-invalid={state.validationInfo.isInvalid}
              aria-describedby={state.validationInfo.isInvalid ? `${idWithFallback}-validation-error` : undefined}
            />
            <label className="form-check-label" htmlFor={`${idWithFallback}-${value.toLocaleLowerCase()}`}>
              {text}
            </label>
          </div>
        ))}
      </div>
      {state.validationInfo.isInvalid && (
        <div id={`${idWithFallback}-validation-error`} className="invalid-feedback">
          {state.validationInfo.errors.map((error) => (
            <div key={error}>{error}</div>
          ))}
        </div>
      )}
    </fieldset>
  );
}

export default RadioFormGroup;
